(() => {
  if (window.kpRijplezierDisplayLoaded) return;
  window.kpRijplezierDisplayLoaded = true;

  const selector = '[data-kp-rijplezier-end]';
  let timeout;
  let refreshQueued = false;

  function refresh() {
    refreshQueued = false;
    window.clearTimeout(timeout);
    const now = Date.now();
    let nextEnd = Infinity;

    document.querySelectorAll(selector).forEach((root) => {
      const endsAt = Number(root.dataset.kpRijplezierEnd) * 1000;
      const active = Number.isFinite(endsAt) && endsAt > now;

      root.querySelectorAll('[data-kp-base], [data-kp-offer]').forEach((part) => {
        if (part.closest(selector) !== root) return;

        const hide = part.hasAttribute('data-kp-offer') ? !active : active;
        part.hidden = hide;

        if (hide) part.style.setProperty('display', 'none', 'important');
        else part.style.removeProperty('display');
      });

      root.classList.toggle('kp-rijplezier-active', active);

      if (root.classList.contains('price')) {
        root.classList.toggle(
          'price--on-sale',
          active || root.dataset.kpBaseSale === 'true'
        );
      }

      if (active) nextEnd = Math.min(nextEnd, endsAt);
    });

    if (Number.isFinite(nextEnd)) {
      timeout = window.setTimeout(
        refresh,
        Math.min(nextEnd - now + 25, 2147483647)
      );
    }
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(refresh);
  }

  function start() {
    const style = document.createElement('style');

    style.textContent =
      '[data-kp-base][hidden],[data-kp-offer][hidden]{display:none!important}' +
      '.price__default[data-kp-offer]{display:flex;flex-wrap:wrap;align-items:baseline;gap:.35em}' +
      '.price__default[data-kp-offer] .price__current{margin:0}' +
      '.kp-rijplezier-note{margin:.4em 0 0;font-size:12px;line-height:1.4;font-weight:400;text-transform:none;letter-spacing:normal}' +
      '.kp-rijplezier-note strong{display:block;font-weight:600}' +
      '.kp-rijplezier-reference{font-size:.8em;opacity:.7;margin-inline-end:.5em}';

    document.head.append(style);
    refresh();

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) =>
        mutation.type === 'attributes' ||
        [...mutation.addedNodes].some((node) =>
          node.nodeType === 1 &&
          (node.matches(selector) ||
            node.querySelector(selector) ||
            node.closest(selector))
        ) ||
        [...mutation.removedNodes].some((node) =>
          node.nodeType === 1 &&
          (node.matches(selector) || node.querySelector(selector))
        )
      )) queueRefresh();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-kp-rijplezier-end', 'data-kp-base-sale']
    });

    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();